import { createAction } from '@reduxjs/toolkit';
export const updatePreviewEntry = createAction('clientEntries/updatePreviewEntry');
export const touchAllFields = createAction('clientEntries/touchAllFields');
export const initializeClientEntries = createAction('clientEntries/initializeClientEntries');
export const addLoopEntry = createAction('clientEntries/addLoopEntry');
export const deleteLoopEntry = createAction('clientEntries/deleteLoopEntry');
export const resetClient = createAction('clientSettings/resetClient');
export const setUnsupportedField = createAction('clientSettings/setUnsupportedField');
export const hideSubmitButton = createAction('clientSettings/hideSubmitButton');
export const setSubmitInProgress = createAction('clientSettings/setSubmitInProgress');
export const setSubmissionSuccessful = createAction('clientSettings/setSubmissionSuccessful');
export const addNewLoopEntry = createAction('clientSettings/addNewLoopEntry');
export const toggleInteractiveClient = createAction('clientSettings/toggleInteractiveClient');